import { Grid, IconButton } from '@material-ui/core';
import './style.css';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { useTranslation } from 'react-i18next';
import { FormTextarea, FormGroup, FormFeedback } from 'shards-react';

const PdfUploader = (props) => {
  const { defaultValue, disabled, inputHasErrors } = props;
  const { t, i18n } = useTranslation();

  return (
    <Grid item container direction="row">
      <div className="image-wrapper cover-logo-wrapper">
        {defaultValue ? (
          <h3>{defaultValue.name}</h3>
        ) : disabled ? (
          <PictureAsPdfIcon style={{ fontSize: '3rem' }} />
        ) : (
          <div className="uploader-div">
            <PictureAsPdfIcon style={{ fontSize: '3rem' }} />
            <h3>{t('book.uploadPdf')}</h3>
            <h4 style={{ color: 'red' }}>{t(inputHasErrors)}</h4>
          </div>
        )}
        {!disabled && (
          <div className="overlay">
            <input accept="application/pdf" style={{ display: 'none' }} id="pdf" type="file" {...props} />
            <label htmlFor="pdf">
              <IconButton aria-label="upload pdf" component="span">
                <PictureAsPdfIcon style={{ fontSize: '3rem' }} />
              </IconButton>
            </label>
          </div>
        )}
      </div>
    </Grid>
  );
};

export default PdfUploader;
